class Drawer {
  constructor() {
    this.drawers = document.querySelectorAll(".drawers__item");
    this.initialSpeed = document.querySelector(".drawers").dataset.speed * 1000;
    this.currentIndex = 0;
    this.autoplayInterval = null;
    this.init();
    // Open first drawer by default
    if (this.drawers.length > 0) {
      const firstDrawer = this.drawers[0];
      const firstInner = firstDrawer.querySelector(".drawers__item-inner");
      const firstTitle = firstDrawer.querySelector(".drawers__item-title");
      const firstSubtitle = firstDrawer.querySelector(
        ".drawers__item-subtitle"
      );
      firstDrawer.classList.add("is-open");
      firstInner.classList.add("is-open");
      firstTitle.classList.remove("text-mono-m");
      firstTitle.classList.add("text-xl");
      firstSubtitle.classList.remove("text-xl");
      firstSubtitle.classList.add("text-mono-l");
      firstInner.style.height = firstInner.scrollHeight + "px";
      setTimeout(() => {
        firstInner.style.height = "auto";
      }, 400);
    }
    // Only start autoplay if viewport width is > 1200px
    if (window.innerWidth > 1200) {
      this.startAutoplay();
    }

    // Add resize listener to handle width changes
    window.addEventListener("resize", () => {
      if (window.innerWidth > 1200) {
        if (!this.autoplayInterval) {
          this.startAutoplay();
        }
      } else {
        this.stopAutoplay();
      }
    });
  }

  init() {
    this.drawers.forEach((drawer, index) => {
      const header = drawer.querySelector(".drawers__item-header");
      const inner = drawer.querySelector(".drawers__item-inner");
      const title = drawer.querySelector(".drawers__item-title");
      const subtitle = drawer.querySelector(".drawers__item-subtitle");

      // Set initial classes for non-first drawers
      if (index !== 0) {
        inner.style.height = "0px";
        title.classList.remove("text-xl");
        title.classList.add("text-mono-m");
        subtitle.classList.remove("text-mono-l");
        subtitle.classList.add("text-xl");
      }

      header.addEventListener("click", () => {
        this.stopAutoplay();
        this.toggleDrawer(drawer, inner);
      });

      // Handle transition end
      inner.addEventListener("transitionend", (e) => {
        if (
          e.propertyName === "height" &&
          drawer.classList.contains("is-open")
        ) {
          inner.style.height = "auto";
        }
      });
    });
  }

  toggleDrawer(drawer, inner) {
    // Close all other drawers with animation
    this.drawers.forEach((otherDrawer) => {
      if (otherDrawer !== drawer && otherDrawer.classList.contains("is-open")) {
        const otherInner = otherDrawer.querySelector(".drawers__item-inner");
        const otherTitle = otherDrawer.querySelector(".drawers__item-title");
        const otherSubtitle = otherDrawer.querySelector(
          ".drawers__item-subtitle"
        );
        otherDrawer.classList.remove("is-open");
        otherInner.style.height = "0px";
        otherInner.classList.remove("is-open");
        otherTitle.classList.remove("text-xl");
        otherTitle.classList.add("text-mono-m");
        otherSubtitle.classList.remove("text-mono-l");
        otherSubtitle.classList.add("text-xl");
      }
    });

    // Toggle current drawer with animation
    const isOpen = drawer.classList.contains("is-open");
    const title = drawer.querySelector(".drawers__item-title");
    const subtitle = drawer.querySelector(".drawers__item-subtitle");

    if (!isOpen) {
      // Opening
      drawer.classList.add("is-open");
      inner.classList.add("is-open");
      inner.style.height = inner.scrollHeight + "px";
      title.classList.remove("text-mono-m");
      title.classList.add("text-xl");
      subtitle.classList.remove("text-xl");
      subtitle.classList.add("text-mono-l");
    } else {
      // Closing
      inner.style.height = inner.scrollHeight + "px";
      setTimeout(() => {
        inner.style.height = "0px";
      }, 0);
      drawer.classList.remove("is-open");
      inner.classList.remove("is-open");
      title.classList.remove("text-xl");
      title.classList.add("text-mono-m");
      subtitle.classList.remove("text-mono-l");
      subtitle.classList.add("text-xl");
    }
  }

  startAutoplay() {
    this.autoplayInterval = setInterval(() => {
      // Close current drawer
      const currentDrawer = this.drawers[this.currentIndex];
      const currentInner = currentDrawer.querySelector(".drawers__item-inner");
      const currentTitle = currentDrawer.querySelector(".drawers__item-title");
      const currentSubtitle = currentDrawer.querySelector(
        ".drawers__item-subtitle"
      );
      currentDrawer.classList.remove("is-open");
      currentInner.style.height = "0px";
      currentInner.classList.remove("is-open");
      currentTitle.classList.remove("text-xl");
      currentTitle.classList.add("text-mono-m");
      currentSubtitle.classList.remove("text-mono-l");
      currentSubtitle.classList.add("text-xl");

      // Move to next drawer
      this.currentIndex = (this.currentIndex + 1) % this.drawers.length;

      // Open next drawer
      const nextDrawer = this.drawers[this.currentIndex];
      const nextInner = nextDrawer.querySelector(".drawers__item-inner");
      const nextTitle = nextDrawer.querySelector(".drawers__item-title");
      const nextSubtitle = nextDrawer.querySelector(".drawers__item-subtitle");
      nextDrawer.classList.add("is-open");
      nextInner.classList.add("is-open");
      nextInner.style.height = nextInner.scrollHeight + "px";
      nextTitle.classList.remove("text-mono-m");
      nextTitle.classList.add("text-xl");
      nextSubtitle.classList.remove("text-xl");
      nextSubtitle.classList.add("text-mono-l");
    }, this.initialSpeed);
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }
}

// Initialize drawers when DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  new Drawer();
});
